import { CallbackComponent } from "redux-oidc";
import { Container } from "reactstrap";
import { Dispatch } from "redux";
import React from "react";
import { UserManager, User } from "oidc-client";
import { connect } from "react-redux";
import { replace } from "connected-react-router";
import { authService } from "../Services/AuthService";

type DispatchProps = { redirect: () => void };

type Props = DispatchProps;
type State = { loaded: boolean };

class SignInCallback extends React.Component<Props, State> {
  userManager?: UserManager;

  constructor(props: Props) {
    super(props);

    this.state = { loaded: false };
    authService.getUserManager().then(userManager => {
      this.userManager = userManager;
      this.setState({ loaded: true });
    });
  }

  postSuccessHandler = (user: User, redirectHandler: (path: string) => void) => {
    const state = JSON.parse(user.state);
    redirectHandler(state.postLoginRedirectPage);
  };

  render() {
    const { redirect } = this.props;
    const { loaded } = this.state;

    const visibleContent = (
      <Container className="p-2">
        <h3 className="text-center">Hold on while we finish logging you in</h3>
      </Container>
    );

    if (loaded) {
      const userManager = this.userManager as UserManager;
      return (
        <CallbackComponent
          successCallback={u => this.postSuccessHandler(u, redirect)}
          errorCallback={redirect}
          userManager={userManager}
        >
          {visibleContent}
        </CallbackComponent>
      );
    }
    return visibleContent;
  }
}

const mapDispatchToProps = (dispatch: Dispatch): DispatchProps => ({
  redirect: (path?: string) => dispatch(replace(path || "/"))
});

export default connect(null, mapDispatchToProps)(SignInCallback);
